import { render, staticRenderFns } from "./BoundDetailsContainer.vue?vue&type=template&id=0307ef9e"
import script from "./BoundDetailsContainer.vue?vue&type=script&lang=js"
export * from "./BoundDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports